import React from 'react';
import Styled from 'styled-components';
import CounterPartsSelector from 'components/CounterPartsSelector';

const CounterPartsFieldStyled = Styled.div`

    &.disabled {
        pointer-events: none;
        user-select: none;
        opacity: 0.5;
    }

    table {

        th {
            background: var(--bs-light);
            font-weight: 500;
        }

        td {

            &:nth-child(1) {
                padding: 0;
            }

            &:nth-child(2) {
                position: relative;

                input {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 100%;
                    padding: 0 10px;
                    border: 0;
                    background: transparent;
                    outline: none;
                    text-align: center;
                }
            }
        }

        th, td {

            &:nth-child(1) {

                .invalid-feedback {
                    padding-left: 8px;
                }
            }

            &:nth-child(2) {
                width: 70px;
                max-width: 70px;
                min-width: 70px;
            }

            &:nth-child(3) {
                width: 40px;
                max-width: 40px;
                min-width: 40px;
                text-align: center;
                vertical-align: middle;

                button {
                    background: transparent;
                    border: 0;
                    color: var(--bs-danger);
                    font-size: 13px;
                    padding: 0;
                    margin: 0;
                    cursor: pointer;

                    &:hover {
                        color: var(--bs-danger);
                    }
                }
            }
        }
    }
`;

export default function CounterPartsField(props) {
    const {counterParts, setCounterParts, year, errors, disabled} = props;

    return (
        <CounterPartsFieldStyled id="counterparts-field" className={disabled ? 'disabled' : ''}>
            <table className="table table-sm table-bordered mb-0">
                <thead>
                    <tr>
                        <th>Contrapartida</th>
                        <th>Porcentaje</th>
                        <th>
                            <button onClick={e => {
                                e.preventDefault();

                                const newCounterParts = counterParts ? [...counterParts] : [];
                                newCounterParts.push({id: null, counterpart: null, percent: newCounterParts.length === 0 ? 100 : null});
                                setCounterParts(newCounterParts);
                            }}>
                                <i className="bi bi-plus-circle-fill text-primary"></i>
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {!counterParts?.length && (
                        <tr>
                            <td colSpan="3" className="text-center">
                                No hay contrapartidas
                            </td>
                        </tr>
                    )}
                    {counterParts?.map((item, index) => (
                        <tr key={index}>
                            <td>
                               <CounterPartsSelector 
                                    onChange={value => {
                                        const newCounterParts = [...counterParts];
                                        newCounterParts[index].id = value.id;
                                        newCounterParts[index].counterpart = value;
                                        newCounterParts[index].percent = newCounterParts[index].percent ?? null;
                                        setCounterParts(newCounterParts);
                                    }}
                                    year={year}
                                    canAdd={false}
                                    value={item.counterpart}
                               />
                               {errors['data.counterparts.' + index + '.id'] && (
                                   <div className="invalid-feedback d-block">
                                       {errors['data.counterparts.' + index + '.id']}
                                   </div>
                               )}
                            </td>
                            <td>
                                <input
                                    type="number"
                                    value={item.percent ?? ''}
                                    onChange={(e) => {
                                        const newCounterParts = [...counterParts];
                                        newCounterParts[index].percent = e.target.value;
                                        setCounterParts(newCounterParts);
                                    }}
                                    className="no-arrows"
                                />
                            </td>
                            <td>
                                <button
                                    type="button"
                                    onClick={() => {
                                        const newCounterParts = counterParts.filter((_, i) => i !== index);
                                        setCounterParts(newCounterParts);
                                    }}
                                >
                                    <i className="bi bi-x-circle-fill"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </CounterPartsFieldStyled>
    );
}